import { FunctionComponent } from 'react';
import { Person } from '../../types';
import GaIntake from './GaIntake';
import HiIntake from './HiIntake';
import PaIntake from './PaIntake';
import GenericIntake from './GenericIntake';

type StateIntakeProps = {
  locationId: string;
  onSubmitSuccess: () => void;
  onEnterLater: () => void;
  peopleData: Person[];
  isFullWidth?: boolean;
  scrollOnMount?: boolean;
};

export const StateIntake: FunctionComponent<StateIntakeProps> = ({
  locationId,
  onSubmitSuccess,
  onEnterLater,
  peopleData,
  isFullWidth,
  scrollOnMount,
}) => {
  switch (locationId) {
    case 'ga':
      return (
        <GaIntake
          onSubmitSuccess={onSubmitSuccess}
          onEnterLater={onEnterLater}
          isFullWidth={isFullWidth}
          scrollOnMount={scrollOnMount}
        />
      );

    case 'hi':
      return (
        <HiIntake
          onSubmitSuccess={onSubmitSuccess}
          onEnterLater={onEnterLater}
          peopleData={peopleData}
          isFullWidth={isFullWidth}
          scrollOnMount={scrollOnMount}
        />
      );

    case 'pa':
      return (
        <PaIntake
          onSubmitSuccess={onSubmitSuccess}
          onEnterLater={onEnterLater}
          isFullWidth={isFullWidth}
          scrollOnMount={scrollOnMount}
        />
      );

    default:
      return (
        <GenericIntake
          onSubmitSuccess={onSubmitSuccess}
          onEnterLater={onEnterLater}
          peopleData={peopleData}
          isFullWidth={isFullWidth}
          scrollOnMount={scrollOnMount}
        />
      );
  }
};
